export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_ExpressJS-147d060cefb187ed0a11a22ab33a08aa.jpg";